module.exports = __webpack_public_path__ + "static/img/2.8b2c686d.jpg";